import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=1b9d783e&scoped=true"
import script from "./weight.vue?vue&type=script&lang=js"
export * from "./weight.vue?vue&type=script&lang=js"
import style0 from "./weight.vue?vue&type=style&index=0&id=1b9d783e&prod&lang=css"
import style1 from "./weight.vue?vue&type=style&index=1&id=1b9d783e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d783e",
  null
  
)

export default component.exports